import React from "react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
    DialogFooter,
} from "../themed/Dialog";
import { EventJourneyStatus } from "@prisma/client";
import { Button } from "../themed/Button";

type Props = {
    isVisible: boolean;
    setIsVisible: (show: boolean) => void;
    newEjs: EventJourneyStatus;
    confirmationCallback: () => void;
    cancelCallback: () => void;
};

const EventJourneyStatusChangeConfirmationModal = ({
    isVisible,
    setIsVisible,
    newEjs,
    confirmationCallback,
    cancelCallback,
}: Props) => {
    return (
        <Dialog onOpenChange={setIsVisible} open={isVisible}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle className="font-faktum text-[20px] text-black">
                        Change Status
                    </DialogTitle>
                    <DialogDescription className="text-v3-neutral">
                        Are you sure you want to change the status of your event
                        to {newEjs}
                    </DialogDescription>
                </DialogHeader>

                <DialogFooter>
                    <Button
                        variant="ghost"
                        className="ml-4 text-background hover:text-tertiary"
                        onClick={() => {
                            setIsVisible(false);
                            cancelCallback();
                        }}
                    >
                        Nevermind
                    </Button>
                    <Button
                        variant="default"
                        className={`
                                  w-[53%]
                                  rounded-[26px]
                                  border
                                  border-background 
                                `}
                        size="lg"
                        onClick={confirmationCallback}
                    >
                        Change Status
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default EventJourneyStatusChangeConfirmationModal;
